import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { fmtNum } from "@/lib/constants";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";

export default function Stock() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  const load = async () => {
    const { data } = await api.get("/admin/stock");
    setRows(data);
  };
  useEffect(() => { load(); }, []);

  const update = async (id, val) => {
    try {
      await api.put(`/admin/stock/${id}`, { stock_amount: parseFloat(val) || 0 });
      toast.success("Güncellendi");
      load();
    } catch {
      toast.error("Hata");
    }
  };

  const filtered = rows.filter((r) =>
    !q || r.product_name.toLowerCase().includes(q.toLowerCase()) || r.label.toLowerCase().includes(q.toLowerCase())
  );

  const lowStock = rows.filter((r) => r.low_stock).length;

  return (
    <div className="space-y-6" data-testid="admin-stock-page">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <span className="label-tag">Stok</span>
          <h1 className="font-serif text-4xl mt-2">Stok Yönetimi</h1>
        </div>
        {lowStock > 0 && (
          <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 px-4 py-2 text-sm text-amber-900">
            <AlertTriangle size={16}/> {lowStock} varyantta düşük stok
          </div>
        )}
      </div>

      <div className="bg-white border border-[#eae5dc] p-4">
        <Input placeholder="Ara: ürün adı veya varyant" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-md" data-testid="admin-stock-search" />
      </div>

      <div className="bg-white border border-[#eae5dc] overflow-x-auto">
        <table className="w-full text-sm min-w-[700px]">
          <thead>
            <tr className="bg-[#f7f5f0] text-xs uppercase tracking-wider text-[#6b655c]">
              <th className="text-left py-3 px-4">Ürün</th>
              <th className="text-left py-3 px-4">Varyant</th>
              <th className="text-left py-3 px-4">Tip</th>
              <th className="text-right py-3 px-4">Stok</th>
              <th className="text-left py-3 px-4">Birim</th>
              <th className="text-right py-3 px-4">İşlem</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={6} className="py-12 text-center text-[#6b655c]">Veri yok</td></tr>}
            {filtered.map((r) => (
              <tr key={r.id} className={`border-t border-[#f0ebe2] ${r.low_stock ? "bg-amber-50/40" : ""}`}>
                <td className="py-3 px-4 font-medium">{r.product_name}</td>
                <td className="py-3 px-4">{r.label}</td>
                <td className="py-3 px-4 text-xs uppercase tracking-wider text-[#c8a97e]">{r.variant_type === "READY_SIZE" ? "Hazır" : "Metre"}</td>
                <td className="py-3 px-4 text-right font-medium">{fmtNum(r.stock_amount)}</td>
                <td className="py-3 px-4 text-[#6b655c]">{r.stock_unit === "piece" ? "Adet" : "Metre"}</td>
                <td className="py-3 px-4 text-right">
                  <StockEditor id={r.id} initial={r.stock_amount} onSave={(v) => update(r.id, v)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function StockEditor({ id, initial, onSave }) {
  const [v, setV] = useState(initial);
  const [open, setOpen] = useState(false);
  return open ? (
    <div className="inline-flex gap-1">
      <Input value={v} onChange={(e) => setV(e.target.value)} className="w-24" type="number" data-testid={`stock-input-${id}`} />
      <Button size="sm" onClick={() => { onSave(v); setOpen(false); }} className="btn-luxe text-xs px-3 py-1" data-testid={`stock-save-${id}`}>Kaydet</Button>
      <Button size="sm" variant="outline" onClick={() => { setV(initial); setOpen(false); }}>İptal</Button>
    </div>
  ) : (
    <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid={`stock-edit-${id}`}>Düzenle</Button>
  );
}
